import { enApp, enWebsite } from './strings';

const en = {
  translation: {
    ...enApp,
    ...enWebsite
  }
};

export default en;
